import React, {useEffect, useState, useRef} from 'react';
//components
import View from './competition-view';
//utils
import {CompetitionService} from '../../../utils/data-transfer';
import {TeamPlayStatus} from '../../../utils/constants';

const _competitionService = new CompetitionService();

const CompetitionContainer = (props) => {
  const {competitionId, competitionPlayerId} = props.match.params;
  const [state, setState] = useState({
    isLoading: true,
    event: null,
    details: null,
    results: [],
    rounds: [],
    bracketMatches: [],
    bracketHash: '',
    viewOpponent: false,
    opponent: { leadPlayer: {}, additionalPlayer: {}, results: []},
    viewEnterResults: false,
    resultsSubmissionLoading: false
  });
  const intervalIteration = useRef(0);
  const interval = useRef(null);

  useEffect(() => {
    getCompetition();

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    }
  }, [competitionId, competitionPlayerId]);

  const getCompetition = async () => {
    try {
      const resp = await Promise.all([
        await _competitionService.getUserCompetitionDetails(competitionId, competitionPlayerId),
        await _competitionService.getUserCompetitionResults(competitionId, competitionPlayerId),
        await _competitionService.getCompetitionRounds(competitionId)]);

      const details = resp[0];

      let opponent;
      if(details.teamPlayStatus.id === TeamPlayStatus.Playing)
        opponent = await _competitionService.getUserCompetitionOpponent(competitionId, details.competitionTeamId);

      let bracket = null;
      if (details.bracketId && !details.hideBracketsInMatchplay && details.isDrawn)
        bracket = await _competitionService.getCompetitionBracket(competitionId, details.bracketId, details.competitionTeamId);

      setState(prevState => ({
        ...prevState,
        details,
        results: resp[1],
        rounds: resp[2],
        bracketMatches: bracket ? bracket.matches : [],
        bracketHash: bracket ? bracket.hash : '',
        isLoading: false,
        opponent
      }));
    } catch (err) {
      console.log(err);
      setState(prevState => ({...prevState, isError: true}));
    }
  };

  const handleSetViewOpponent = async (viewOpponent) =>
    setState(prevState => ({...prevState, viewOpponent }));

  const handleSetViewEnterResults = async (viewEnterResults) =>
    setState(prevState => ({...prevState, viewEnterResults}));

  const handleResultsSubmission = async (resultsEntry) => {
    try {
      setState(prevState => ({...prevState, resultsSubmissionLoading: true }));

      await _competitionService.setMatchResults(competitionId, state.details.competitionMatchId, resultsEntry);
      await getCompetition();

      setState(prevState => ({...prevState, resultsSubmissionLoading: false, viewEnterResults: false  }));

      interval.current = setInterval(async () => {
        if (!state.details.newDrawPerRound) {
          let bracket = await _competitionService.getCompetitionBracket(competitionId, state.details.bracketId, state.details.competitionTeamId);
          if (bracket.hash !== state.bracketHash) {
            clearInterval(interval.current);
            await getCompetition();
          } else {
            await getCompetition();
            intervalIteration.current++;

            if (intervalIteration.current > 1) {
              intervalIteration.current = 0;
              clearInterval(interval.current);
            }
          }
        }
      }, 3000);
    } catch (err) {
      console.log(err);
      props.history.push('/error?errorMessage=An unexpected error occurred when entering your results.\nPlease try again shortly.\nIf this error persists please Contact Us.');
    }
  };

  return (
    <View
      {...state}
      handleSetViewOpponent={handleSetViewOpponent}
      handleSetViewEnterResults={handleSetViewEnterResults}
      handleResultsSubmission={handleResultsSubmission}/>
  )
}

export default CompetitionContainer;
